export default [
    {
        path: '/login',
        component: () => import('./login.vue'),
    },
    {
        path: '/login/:redirectUrl',
        component: ()=>import('./login.vue'),
        props: true,
    }
]